var render = function render(_c,_vm){return _c('i',{class:[
    { 'el-icon-circle-check': _vm.props.rowValue === true },
    {
      'el-icon-circle-close':
        _vm.props.rowValue === null || _vm.props.rowValue === false
    }
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }